/**
 * The current path, as context.
 *
 * Separate from `router.tsx` so that file exports components only — React Fast Refresh
 * cannot hot-swap a module that also exports hooks or constants, and falls back to a full
 * reload that loses your state.
 */

import { createContext, useContext } from "react";

export const PathContext = createContext<string>("/");

export function usePath(): string {
  return useContext(PathContext);
}
